import React, { createContext, useState, useCallback, useEffect } from 'react';

export const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    console.log('[LoaderContext] isLoading state:', isLoading);
  }, [isLoading]);

  const showLoader = useCallback(() => {
    console.log('[LoaderContext] showLoader() called');
    setIsLoading(true);
  }, []);

  const hideLoader = useCallback(() => {
    console.log('[LoaderContext] hideLoader() called');
    setIsLoading(false);
  }, []);

  const value = {
    isLoading,
    showLoader,
    hideLoader,
  };

  return (
    <LoaderContext.Provider value={value}>
      {children}
    </LoaderContext.Provider>
  );
};
